import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { Box, Button, ButtonGroup } from '@mui/material';
import { setMainPageLangAction } from 'store/actions/mainPage';
import { ILang, MainLangType } from 'types/mainPage';
import { NAMES } from 'utils/constantNames';

const langs: ILang[] = [
  { lang: NAMES.LANG_RUS, value: 'ru' },
  { lang: NAMES.LANG_BEL, value: 'by' },
  { lang: NAMES.LANG_ENG, value: 'en' },
];

export const LangBtns: React.FC = () => {
  const { lang } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();
  const onChangeLang = (lang: MainLangType) => {
    dispatch(setMainPageLangAction(lang));
  };

  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.custom.transparentWhite,
        mr: '2px',
        mt: '1px',
        alignSelf: 'baseline',
      }}
    >
      <ButtonGroup variant="text">
        {langs.map((item) => {
          return (
            <Button
              key={item.value}
              sx={{
                color: (theme) =>
                  lang === item.value
                    ? theme.palette.primary.main
                    : theme.palette.grey[600],
              }}
              onClick={() => {
                onChangeLang(item.value);
              }}
            >
              {item.lang}
            </Button>
          );
        })}
      </ButtonGroup>
    </Box>
  );
};
